// extracted by mini-css-extract-plugin
export default {"suggested-container":"SuggestedProduct_suggested-container__eDis1"};